export * from "@vaadin/tabs/vaadin-tab.js";
export * from './generated/Tab.js';
